import React from "react";
import { Link, useLocation } from "react-router-dom";

export default function Sidebar({ sidebarOpen, setSidebarOpen }) {
  const location = useLocation();

const menuItems = [
  { path: "/", label: "Dashboard", icon: "📊" },
  { path: "/products", label: "Products", icon: "🛒" },
  { path: "/category", label: "Category", icon: "🗂️" },
  { path: "/banners", label: "Banners", icon: "🖼️" },
  { path: "/testimonials", label: "Testimonials", icon: "💬" },
  { path: "/enquiries", label: "Enquiries", icon: "📩" },
  { path: "/conactus", label: "Contact Us", icon: "📞" },
  { path: "/blogs", label: "Blogs", icon: "📝" },
  { path: "/orders", label: "Orders", icon: "📦" },
  { path: "/order-tracking", label: "Order Tracking", icon: "🚚" },
  { path: "/payments", label: "Payments", icon: "💳" },
  { path: "/reviews", label: "Reviews", icon: "⭐" },
  { path: "/clients", label: "Clients", icon: "👥" },
  { path: "/video-collection", label: "Video Collection", icon: "🎥" },
  { path: "/cart-collection", label: "Cart Collection", icon: "🛍️" },
  { path: "/wishlist-collection", label: "Wishlist Collection", icon: "❤️" },
];


  const isActiveLink = (path) => {
    return location.pathname === path;
  };

  return (
    <>
      {/* Mobile overlay */}
      <div
        className={`fixed inset-0 bg-[#0d5fa9] z-30 md:hidden transition-opacity duration-300 ${
          sidebarOpen ? "opacity-100" : "opacity-0 pointer-events-none"
        }`}
        onClick={() => setSidebarOpen(false)}
      ></div>

      {/* Sidebar */}
      <div
        className={`
          fixed z-40 h-screen bg-[#0d5fa9] shadow-xl p-5 transition-all duration-300
          ${sidebarOpen ? "left-0 w-64" : "-left-64 w-64"}
          md:relative md:left-0 md:w-64  overflow-y-auto
        `}
      >
        {/* Header */}
        <div className="flex items-center justify-between mb-10 pb-4 border-b border-blue-700">
          <div className="flex items-center space-x-3">
            <h2 className="text-xl font-bold text-white">DMS Admin Panel</h2>
          </div>
          <button
            className="md:hidden text-white hover:bg-blue-700 p-1 rounded"
            onClick={() => setSidebarOpen(false)}
          >
            ✕
          </button>
        </div>

        {/* Navigation */}
        <ul className="space-y-2">
          {menuItems?.map((item) => (
            <li key={item.path}>
              <Link
                to={item.path}
                className={`flex items-center space-x-3 p-3 rounded-lg transition-all duration-200 ${
                  isActiveLink(item.path)
                    ? "bg-white text-blue-700 shadow-md"
                    : "text-blue-100 hover:bg-blue-700 hover:text-white"
                }`}
                onClick={() => setSidebarOpen(false)}
              >
                <span className="text-lg">{item.icon}</span>
                <span className="font-medium">{item.label}</span>
              </Link>
            </li>
          ))}
        </ul>

        {/* Footer */}
        {/* <div className="absolute bottom-5 left-5 right-5 text-center text-blue-200 text-sm">
          <p>© 2023 E-Commerce</p>
        </div> */}
      </div>
    </>
  );
}
